import React from "react";
import "./App.css";
import AppRoute from "./Routes/app-router";

function App() {
  return (
    <div className="App">
      <AppRoute />
    </div>
  );
}

export default App;
